import {
  VALIDATE_COUPON_REQUEST,
  VALIDATE_COUPON_SUCCESS,
  VALIDATE_COUPON_FAILURE,
  VALIDATE_COUPON_RESET
} from "../constants";

interface CouponData {
  couponId: number;
  offerType: number;
  discountAmount: string;
}

interface ActionType {
  type: string;
  payload?: {
    data?: CouponData;
    error?: string;
  };
}

const initialState = {
  couponRequest: false,
  couponData: {
    couponId: 0,
    offerType: 0,
    discountAmount: "0"
  } as CouponData,
  couponStatus: false,
  couponError: null as string | null
};

export const couponReducer = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case VALIDATE_COUPON_REQUEST:
      return {
        ...state,
        couponRequest: true,
        couponData: initialState.couponData,
        couponStatus: false,
        couponError: null
      };

    case VALIDATE_COUPON_SUCCESS:
      return {
        ...state,
        couponRequest: false,
        couponData: action.payload?.data ?? initialState.couponData,
        couponStatus: true,
        couponError: null
      };

    case VALIDATE_COUPON_FAILURE:
      return {
        ...state,
        couponRequest: false,
        couponData: initialState.couponData,
        couponStatus: false,
        couponError: action.payload?.error || null
      };

    case VALIDATE_COUPON_RESET:
      return initialState;

    default:
      return state;
  }
};
